import { FormField } from "@tellescope/types-models";
import { FormFieldNode, Indexable } from "./types";

/**
 * Builds a tree structure from a flat array of form fields
 * Creates parent-child relationships based on previousFields
 * Returns the root node of the tree
 */
export const buildTreeFromFields = (providedFields: FormField[]): FormFieldNode | undefined => {
  // ensure all fields actually belong to the same form
  const fields = providedFields.filter((f) => f.formId === providedFields[0]?.formId);
  if (!fields.length) return undefined;

  const nodesForId = {} as Indexable<FormFieldNode>;
  fields.forEach((step) => {
    nodesForId[step.id] = {
      value: step,
      children: [],
    };
  });

  for (const parentId in nodesForId) {
    const parent = nodesForId[parentId];

    for (const childId in nodesForId) {
      if (childId === parentId) continue;
      const child = nodesForId[childId];

      if (child?.value.previousFields.find((p) => "fieldId" in p.info && p.info.fieldId === parentId) && parent) {
        parent.children.push(child);
      }
    }
  }

  // find and return root
  return nodesForId[fields.find((s) => s.previousFields.find((p) => p.type === "root"))?.id ?? ""];
};
